export default __webpack_public_path__ + "media/zurb/img/events/wired/pie-ranch/pie-ranch-thumb-f0b235398093982effe1f0c36bdc7f5f.png";